import React, { useState } from "react";

import Filters from "./filters";

import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import FilterListIcon from "@mui/icons-material/FilterList";
import { Tooltip, Typography } from "@mui/material";

const Searchbar = ({ onChange, onFilterChange, type }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget.parentElement);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleFilterChange = (filters) => {
    console.log("Filters received in Searchbar:", filters);
    onFilterChange(filters, type);
  };

  return (
    <>
      <Paper
        component="form"
        sx={{ p: "2px 4px", display: "flex", alignItems: "center" }}
        elevation={1}
      >
        <Typography
          sx={{ ml: 1, flex: 1 }}
          fullWidth
          inputProps={{ "aria-label": "Search" }}
          userSelect="none"
        >
          Search filters
        </Typography>

        <Tooltip title="Advanced Search" arrow>
          <IconButton
            sx={{ p: "10px" }}
            aria-label="menu"
            onClick={handleClick}
          >
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      </Paper>
      <Filters
        anchorEl={anchorEl}
        handleClose={handleClose}
        type={type}
        onFilterChange={handleFilterChange}
      />
    </>
  );
};

export default Searchbar;
